import React from "react";
import ReactMarkdown from "react-markdown";
import SiteNav from "../components/SiteNav";
import SiteFooter from "../components/SiteFooter";
import Hero from "../components/Hero";
import { resolveImageUrl } from "../lib/api";
import { useSettings } from "../context/SettingsContext";

const FALLBACK_FLOATING =
  "https://images.unsplash.com/photo-1607746882042-944635dfe10e?crop=entropy&cs=srgb&fm=jpg&q=80&w=600";

export default function About() {
  const { settings } = useSettings();

  const floatingImage =
    resolveImageUrl(settings.about_floating_image || "") || FALLBACK_FLOATING;

  return (
    <div
      className="relative h-screen w-screen overflow-hidden bg-white text-zinc-900"
      data-testid="about-page"
    >
      <SiteNav />
      <Hero
        imageKey="about_hero_image"
        leftKey="about_hero_left"
        rightKey="about_hero_right"
      />

      <main
        data-testid="about-main"
        className="relative w-full h-[calc(67vh-72px)] overflow-hidden"
      >
        <section className="relative h-full max-w-6xl mx-auto px-6 md:px-12 flex items-center fade-up">
          <div className="grid grid-cols-1 md:grid-cols-[auto_1fr] gap-8 md:gap-14 items-center w-full">
            {/* Portrait — 3x3 inch with offset shadow */}
            <div className="flex justify-center md:justify-start">
              <div
                data-testid="about-floating-image"
                className="relative bg-white border border-black/90 shadow-[8px_8px_0_0_#0A0A0A] overflow-hidden"
                style={{
                  width: "clamp(220px, 22vw, 288px)",
                  height: "clamp(220px, 22vw, 288px)",
                }}
              >
                <img
                  src={floatingImage}
                  alt={settings.about_me_heading || "Portrait"}
                  className="w-full h-full object-cover"
                  draggable={false}
                />
              </div>
            </div>

            {/* About text */}
            <div className="max-w-xl">
              <span className="font-display text-[10px] md:text-xs font-bold uppercase tracking-[0.32em] text-[#002FA7] mb-3 block">
                ◆ About Me
              </span>
              <h1 className="font-display font-black tracking-[-0.035em] leading-[0.92] text-4xl md:text-5xl lg:text-6xl mb-5">
                {settings.about_me_heading || "The story behind the notes."}
              </h1>
              <div
                data-testid="about-me-body"
                className="text-zinc-600 text-[13px] md:text-sm leading-relaxed prose prose-sm prose-zinc max-w-xl prose-strong:text-zinc-900 prose-strong:font-semibold prose-p:my-2 prose-a:text-[#002FA7]"
              >
                <ReactMarkdown>
                  {settings.about_me_body || "Tell your story here. Edit this text from /admin → Site → About Page."}
                </ReactMarkdown>
              </div>
            </div>
          </div>
        </section>
      </main>

      <SiteFooter />
    </div>
  );
}
